<div class="container mainbox">
    <form [formGroup]="mainForm" *ngIf="dataLoaded; else loading">
        <h1 class="form-group title-position" style="margin-top: 20px;" translate>smsCampaign.title</h1>

        <div id="mainContent" role="tablist" aria-multiselectable="true">
            <div class="card">
                <div class="card-header" id="mainSection">
                    <h5 class="mb-0">
                        <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseMainSection"
                            aria-expanded="true" aria-controls="collapseMainSection" translate>
                            smsCampaign.mainSection
                        </button>
                    </h5>
                </div>
                <div id="collapseMainSection" class="collapse show" aria-labelledby="mainSection" data-parent="#mainContent">
                    <div class="card-body">
                        <div class="container-fluid row">

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;">
                                    <span translate>smsCampaign.name</span> <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" formControlName="name"
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{ 'is-invalid': showValidations && f.name.errors }">
                                <div class="invalid-feedback" *ngIf="f.name.errors?.required && showValidations" translate>errors.required</div>
                                <div class="invalid-feedback" *ngIf="f.name.errors?.maxlength && showValidations">{{"errors.inputTooLong" | translate: {max: 255} }}</div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;" translate>smsCampaign.status</label>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="isActiveSwitch"
                                        formControlName="isActive">
                                    <label class="custom-control-label" for="isActiveSwitch">
                                        <span *ngIf="f.isActive.value" translate>smsCampaign.status.active</span>
                                        <span *ngIf="!f.isActive.value" translate>smsCampaign.status.inactive</span>
                                    </label>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;">
                                    <span translate>smsCampaign.technicalPoints</span> <span class="text-danger">*</span>
                                </label>
                                <mat-form-field class="w-100">
                                    <mat-select multiple formControlName="technicalPoints"
                                        placeholder="{{'placeholder.select' | translate}}">
                                        <mat-option *ngFor="let technicalPoint of technicalPoints" [value]="technicalPoint.mobileAppId">
                                            {{technicalPoint.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="text-danger small" *ngIf="f.technicalPoints.errors?.required && showValidations" translate>errors.required</div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;">
                                    <span translate>smsCampaign.notificationTime</span> <span class="text-danger">*</span>
                                </label>
                                <div class="d-flex" style="gap: 10px;">
                                    <select class="custom-select" formControlName="notifHour"
                                        [ngClass]="{ 'is-invalid': showValidations && f.notifHour.errors }">
                                        <option [ngValue]="null" disabled translate>placeholder.select</option>
                                        <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
                                    </select>
                                    <select class="custom-select" formControlName="notifMinute">
                                        <option *ngFor="let minute of minutes" [ngValue]="minute">{{minute}}</option>
                                    </select>
                                </div>
                                <div class="text-danger small" *ngIf="f.notifHour.errors?.required && showValidations" translate>errors.required</div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;">
                                    <span translate>smsCampaign.incomingWays</span> <span class="text-danger">*</span>
                                </label>
                                <mat-form-field class="w-100">
                                    <mat-select multiple formControlName="incomingWays"
                                        placeholder="{{'placeholder.select' | translate}}">
                                        <mat-option *ngFor="let way of incomingWays" [value]="way.code">
                                            {{way.nameKey | translate}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="text-danger small" *ngIf="f.incomingWays.errors?.required && showValidations" translate>errors.required</div>
                            </div>

                            <div class="col-12">
                                <label style="margin-top: 12px;">
                                    <span translate>smsCampaign.messageText</span> <span class="text-danger">*</span>
                                </label>
                                <textarea class="form-control" rows="4" formControlName="messageText"
                                    [attr.maxlength]="messageMaxLength"
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{ 'is-invalid': showValidations && f.messageText.errors }"></textarea>
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <div class="text-danger small" *ngIf="f.messageText.errors?.required && showValidations" translate>errors.required</div>
                                    </div>
                                    <small class="form-text"
                                        [class.text-danger]="messageLength >= messageMaxLength"
                                        [class.text-muted]="messageLength < messageMaxLength">
                                        {{messageLength}} / {{messageMaxLength}}
                                    </small>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="d-flex justify-content-end" style="gap: 10px;" *ngIf="dataLoaded">
        <button class="btn btn-primary w-20" type="button"
            [disabled]="disableActionBtn" style="margin-top: 10px;" (click)="save()" translate>button.save</button>
    </div>

    <ng-template #loading>
        <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
            <div class="alert alert-danger">
                {{errorMessage}}
            </div>
            <div class="d-flex justify-content-center">
                <i class="fa fa-refresh" (click)="reload()"></i>
            </div>
        </div>
        <ng-template #spinner>
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </ng-template>
    </ng-template>
</div>
